<template>
  <AdsButton
    v-bind="$attrs"
    :loading="$store.state.isLoading"
    secondary
    outlined
    class="mr-3"
    icon="mdi-content-save-outline"
    button-text="Save"
    v-on="$listeners"
  />
</template>

<script>
import {AdsButton} from '@nswdoe/doe-ui-core';

export default {
  name: 'SaveButtonForPublisher',
  components: {AdsButton}
}
</script>

<style lang="scss" scoped>

</style>
